<template>
  <BaseIcon
    :active="active"
    :dark-mode="darkMode"
    :width="width"
    :height="height"
    :svg-path="'M11.2275 20.4321C11.187 20.5944 11.0933 20.7384 10.9615 20.8413C10.8297 20.9443 10.6673 21.0002 10.5 21.0002C10.4368 21.0005 10.3738 20.993 10.3125 20.9777L7.31251 20.2277C7.22899 20.2067 7.14971 20.1715 7.07814 20.1237L4.82814 18.6237C4.66267 18.5133 4.54783 18.3417 4.50889 18.1466C4.46994 17.9515 4.51009 17.749 4.62048 17.5835C4.73088 17.418 4.90249 17.3032 5.09755 17.2643C5.29262 17.2253 5.49517 17.2655 5.66064 17.3758L7.80189 18.8037L10.6763 19.5227C10.7723 19.546 10.8628 19.588 10.9425 19.6464C11.0223 19.7048 11.0897 19.7783 11.1409 19.8628C11.1921 19.9473 11.2262 20.0411 11.241 20.1388C11.2559 20.2365 11.2513 20.3362 11.2275 20.4321ZM23.6672 11.389C23.6057 11.5759 23.5077 11.7488 23.379 11.8976C23.2502 12.0465 23.0933 12.1683 22.9172 12.2562L20.6972 13.3662L15.5335 18.5308C15.4418 18.6224 15.328 18.6887 15.2031 18.7232C15.0783 18.7577 14.9466 18.7592 14.821 18.7277L8.82095 17.2277C8.72971 17.2048 8.64354 17.1651 8.56689 17.1105L3.36189 13.3943L1.08564 12.2562C0.72989 12.0783 0.459333 11.7665 0.333457 11.3892C0.207581 11.0119 0.236691 10.6001 0.414388 10.2443L2.74408 5.58585C2.92191 5.2301 3.23375 4.95955 3.61103 4.83367C3.98831 4.70779 4.40013 4.7369 4.75595 4.9146L6.82408 5.94585L11.7928 4.52648C11.9276 4.48792 12.0705 4.48792 12.2053 4.52648L17.1741 5.94585L19.2422 4.9146C19.598 4.7369 20.0098 4.70779 20.3871 4.83367C20.7644 4.95955 21.0762 5.2301 21.2541 5.58585L23.5838 10.2443C23.6726 10.4201 23.7257 10.6118 23.7401 10.8083C23.7544 11.0048 23.7296 11.2021 23.6672 11.389ZM19.3378 12.6021L16.7869 7.50023H13.8038L9.75001 11.4377C10.9369 12.1962 12.7978 12.4052 14.4675 10.7224C14.5979 10.591 14.7723 10.5124 14.9572 10.5019C15.142 10.4913 15.3242 10.5495 15.4688 10.6652L18.6947 13.2499L19.3378 12.6021ZM1.75595 10.9146L3.41439 11.7443L5.74408 7.08585L4.08564 6.25616L1.75595 10.9146ZM17.625 14.3121L15.0272 12.2318C13.1953 13.7318 10.8694 13.9296 8.94189 12.7005C8.75228 12.5799 8.5922 12.4183 8.47347 12.2275C8.35473 12.0367 8.28038 11.8217 8.2559 11.5983C8.23142 11.3749 8.25744 11.1489 8.33204 10.9369C8.40664 10.725 8.52791 10.5325 8.68689 10.3737C8.68915 10.3709 8.69166 10.3684 8.69439 10.3662L12.9 6.2871L12 6.03023L7.27314 7.38116L4.7072 12.5121L9.3197 15.8074L14.7703 17.1696L17.625 14.3121ZM22.2413 10.9146L19.9144 6.25616L18.2559 7.08585L20.5856 11.7443L22.2413 10.9146Z'" />
</template>
<script>
import BaseIcon from "./BaseIcon.vue"
export default {
  components: {
    BaseIcon
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    darkMode: {
      type: Boolean,
      default: false
    },
    width: {
      type: [Number, String],
      default: 24
    },
    height: {
      type: [Number, String],
      default: 24
    }
  }
}
</script>
